import React, { CSSProperties } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import { Card, CardContent, CardDescription, CardGroup, CardHeader, CardMeta, Icon } from 'semantic-ui-react'

type Props = {}

interface styles {
    CardGroupStyle: CSSProperties
}
const styles: styles = {
    CardGroupStyle: {
        // backgroundColor: 'black',
        display: 'flex',
        justifyContent: 'center',
        padding: '2rem',
        // textDecoration: 'none',
    }
}

const Monitoring = (props: Props) => {
    const Alert = () => {
        toast.error('Alert')
        // setInterval(() => {
        //     toast.error('Alert')
        // }, 3000);
    }
    return (
        <div>
            <ToastContainer />
            <CardGroup style={styles.CardGroupStyle}>
                <Card onClick={() => Alert()}>
                    <CardContent>
                        <CardHeader>Weather Alert <Icon color='blue' name='rain' /></CardHeader>
                        <CardMeta>Severity of alert</CardMeta>
                        <CardDescription>
                            Route of alert
                        </CardDescription>
                    </CardContent>
                    <CardContent extra>
                        <Icon color='red' name='eye slash' /> unseen
                    </CardContent>
                </Card>
                <Card onClick={() => Alert()}>
                    <CardContent>
                        <CardHeader>Traffic Alert <Icon name='road' /> <Icon color='red' name='exclamation triangle' /></CardHeader>
                        <CardMeta>Severity of alert</CardMeta>
                        <CardDescription>
                            Route of alert
                        </CardDescription>
                    </CardContent>
                    <CardContent extra>
                        <Icon color='blue' name='eye' /> seen
                    </CardContent>
                </Card>
                <Card onClick={() => Alert()}>
                    <CardContent>
                        <CardHeader>Alert <Icon color='red' name='question' /></CardHeader>
                        <CardMeta>Severity of alert</CardMeta>
                        <CardDescription>
                            Route of alert
                        </CardDescription>
                    </CardContent>
                    <CardContent extra>
                        <Icon color='blue' name='eye' /> seen
                    </CardContent>
                </Card>
                <Card onClick={() => Alert()}>
                    <CardContent>
                        <CardHeader>Freezing Tempetures <Icon color='blue' name='snowflake outline' /></CardHeader>
                        <CardMeta>Severity of alert</CardMeta>
                        <CardDescription>Route of alert</CardDescription>
                    </CardContent>
                    <CardContent extra><Icon color='blue' name='eye' /></CardContent>
                </Card>
            </CardGroup>
        </div>
    )
}

export default Monitoring